// extracted by mini-css-extract-plugin
export default {"header":"navbar_header__5LJK0"};